import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title?: string;
  description?: string;
}

const SITE_URL = "https://makemyday.tips";
const DEFAULT_TITLE = "MakeMyDay | Daily Positive Messages & Well-Being App";
const DEFAULT_DESCRIPTION =
  "MakeMyDay helps you improve every day with uplifting messages, supportive communities, and positive technology designed for well-being.";
// Absolute URL — social crawlers don't reliably resolve relative og:image paths.
const DEFAULT_IMAGE = `${SITE_URL}/assets/icons/og-image.png`;

const SEO: React.FC<SEOProps> = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
}) => {
  const url = `${SITE_URL}${useLocation().pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:site_name" content="MakeMyDay" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={DEFAULT_IMAGE} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@MakeMyDayAI" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
    </Helmet>
  );
};

export default SEO;
